export default __webpack_public_path__ + "static/media/22.3154e29a.png";